// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user[data-v-03d6666e]{min-height:calc(var(--vh, 1vh)*100 - 203px);background-size:cover;background-position:50%;background-repeat:no-repeat}.user-card[data-v-03d6666e]{max-width:450px;background-color:hsla(0,0%,100%,.9);padding:30px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
